type Props = {
	videoId: string;
};

/**
 * YouTube埋め込みプレーヤーコンポーネント
 */
export const YouTubeEmbed = ({ videoId }: Props) => {
	return (
		<div className="my-4 aspect-video w-full max-w-2xl overflow-hidden rounded-lg border border-zinc-200 shadow-sm">
			<iframe
				src={`https://www.youtube.com/embed/${videoId}`}
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowFullScreen
				className="h-full w-full"
			/>
		</div>
	);
};
